import { CheckoutAdapter } from '@spartacus/checkout/base/core';
import { Observable } from 'rxjs';

export abstract class CustomUnavailableProductsAdapter extends CheckoutAdapter {

  abstract unavailableProducts(
    userId: string,
    cartId: string,
  ): Observable<any[]>;

}
